export const CHECKOUT_ROUTE = '/v2/checkout';
export const CART_MERGE_HEADING = 'Bag updated';
export const CART_MERGE_TEXT =
  'Your bag has been updated with item(s) added previously from another device.';
export const BUTTON_TEXT_REVIEW = 'Review Cart';
export const BUTTON_TEXT_OK = 'Got it';
export const NAV_KEY = 'cart-merge';
export enum PAGE_TYPES {
  MWEB_ADDRESS,
  DWEB_ADDRESS,
  CART,
  COUPONS,
}

export const IMAGE_URL =
  'https://images-static.nykaa.com/nykdesignstudio-images/pub/media/image-2022-01-13-16-16-17-704.png';

export const IMAGE_ALT_TEXT = 'bag updated';
